import { CardWrapper } from "@components";
import { Box, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: "30%",
    maxWidth: "50%",
  },
}));

interface Props {
  requestor: {
    name: string | null;
    email: string | null;
    phoneNumber: string | null;
    location: string | null;
  };
}

export const RequestorDetails: React.FC<Props> = ({ requestor }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <CardWrapper title="Requestor Details">
        <Box p={3}>
          <Grid container direction="row">
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Name:</b>
                </span>{" "}
                {requestor.name}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Email:</b>
                </span>{" "}
                {requestor.email}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Phone Number:</b>
                </span>{" "}
                {requestor.phoneNumber}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Location:</b>
                </span>{" "}
                {requestor.location}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </CardWrapper>
    </Box>
  );
};
